/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Manage_Storage_Schedule_CanceledInputs */



/**
* | output |
* | --- |
* | "Scheduled storage change canceled." |
*
* @param {Partner_Manage_Storage_Schedule_CanceledInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_manage_storage_schedule_canceled = /** @type {((inputs?: Partner_Manage_Storage_Schedule_CanceledInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Manage_Storage_Schedule_CanceledInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Geplante Speicheränderung abgebrochen.")
	return /** @type {LocalizedString} */ ("Scheduled storage change canceled.")
});